import { computed, observable, toJS } from 'mobx';
import AssetSceneModel from './AssetSceneModel';
import AssetMediaSegment from './AssetMediaSegment';
import AssetLocationModel from './AssetLocationModel';
import AssetStore from './AssetStore';

export default class AssetModel {
    id = null;

    @observable type = null;

    @observable name = null;

    @observable mimeType = null;

    @observable description = null;

    @observable externalReferences = null;

    @observable tags = null;

    @observable locations = null;

    @observable related = null;

    @observable metadata = null;

    @observable logs = null;

    @observable createdAt = null;

    @observable updatedAt = null;

    // TODO Deprecated
    @observable scenes = null;

    @observable segments = null;

    @observable sceneLabelFilter = null;

    auth = null;

    @observable assetStore = null;

    @computed
    get sortedMetadata() {
        const ordered = {};
        if (!this.metadata) {
            return {};
        }
        Object.keys(this.metadata)
            .sort()
            .forEach((key) => {
                ordered[key] = this.metadata[key];
            });
        return ordered;
    }

    // Preview Managemnet
    // @observable stillPreviews = null;
    @computed
    get stillPreviews() {
        // Lazy load
        if (!this.assetStore.fetchedStillPreviews && !this.assetStore.fetchingPreviews) {
            this.assetStore.fetchStillPreviews(this.id);
        }
        return this.assetStore.assetStillPreviews;
    }

    @computed
    get audioPreviews() {
        // Lazy load
        if (!this.assetStore.fetchedAudioPreviews && !this.assetStore.fetchingAudioPreviews) {
            this.assetStore.fetchAudioPreviews(this.id);
        }
        return this.assetStore.assetAudioPreviews;
    }

    @computed
    get scenesWithLabel() {
        // TODO put this in DB an select properone
        return this.scenes.filter((s) => s);
    }

    getDataFromLocation = (location) => {
        if (location.startsWith('metadata.')) {
            const meta = location.replace('metadata.', '');
            return this.metadata ? this.metadata[meta] : '';
        }
        return this[location];
        // TODO
        // return 'Not Implemented yet';
    };

    constructor(
        auth,
        id,
        type,
        name,
        mimeType,
        description,
        externalReferences,
        tags,
        locations,
        related,
        metadata,
        logs,
        createdAt,
        updatedAt,
        scenes,
        mediaSegments,
        relation,
    ) {
        this.auth = auth;

        this.id = id;
        this.type = type;
        this.name = name;
        this.mimeType = mimeType;
        this.description = description;
        this.externalReferences = externalReferences;
        this.tags = tags;
        this.locations = locations;
        this.related = related;
        this.metadata = metadata;
        this.logs = logs;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;

        this.scenes = scenes;
        this.segments = mediaSegments;
        this.relation = relation;

        this.assetStore = new AssetStore(this.auth);
    }

    toJS() {
        toJS(this);
    }

    static fromJS(auth, object, relation) {
        const scenes = object.scenes ? object.scenes.map((s) => AssetSceneModel.fromJS(s)) : [];
        const segments = object.segments
            ? object.segments.map((s) => AssetMediaSegment.fromJS(s))
            : [];
        const locations = object.locations
            ? object.locations.map((l) => AssetLocationModel.fromJS(auth, l))
            : [];
        return new AssetModel(
            auth,
            object.id,
            object.type,
            object.name,
            object.mime_type,
            object.description,
            object.external_references,
            object.tags,
            locations,
            object.related,
            object.metadata,
            object.logs,
            object.created_at,
            object.updated_at,
            scenes,
            segments,
            relation,
        );
    }
}
